import React from 'react';
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const contactItems = [
  {
    icon: <FaPhoneAlt className="text-blue-500 text-2xl" />,
    label: 'Phone',
    value: '+91 94880 36003',
    link: 'tel:+919488036003',
  },
  {
    icon: <FaWhatsapp className="text-green-500 text-2xl" />,
    label: 'WhatsApp',
    value: '+91 94880 36003',
    link: 'https://wa.me/94880 36003',
  },
  {
    icon: <FaEnvelope className="text-red-500 text-2xl" />,
    label: 'Email',
    value: 'ramasamyt33@gmail.com',
    link: 'mailto:ramasamyt33@gmail.com',
  },
  {
    icon: <FaMapMarkerAlt className="text-yellow-500 text-2xl" />,
    label: 'Address',
    value: 'Ram Engineer, Kabilarmalai, P.Velur, Namakkal, India',
    link: null,
  },
];

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-white py-20 px-6 md:px-16">
      <h1 className="text-4xl md:text-5xl font-extrabold text-center text-black mb-8">
        Contact Us
      </h1>
      <p className="text-center text-gray-600 mb-16 mx-auto md:text-2xl font-semibold">
        We'd love to hear from you. Reach us through any of the options below.
      </p>

      {/* Horizontal floating staircase layout */}
      <div className="relative flex flex-wrap justify-center gap-6 max-w-7xl mx-auto">
        {contactItems.map((item, idx) => (
          <div
            key={idx}
            className="bg-black text-white p-6 rounded-xl shadow-lg w-64 transition-all duration-300 hover:-translate-y-2"
            style={{
              position: 'relative',
              top: `${idx * 40}px`, // vertical shift
              zIndex: `${999 - idx}`,
            }}
            data-aos="fade-down-right"
            data-aos-duration={`${1500+((idx+1)*200)}`}
          >
            <div className="flex items-center gap-4 mb-3">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold">{item.label}</h3>
            </div>
            {item.link ? (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-400 hover:underline block pl-2"
              >
                {item.value}
              </a>
            ) : (
              <p className="text-gray-300 pl-16">{item.value}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactUs;
